export default __webpack_public_path__ + "static/media/outsource.0990ba70.svg";